export default __webpack_public_path__ + "static/media/up-arrow.35715bed.svg";